import React, {useState} from "react";
import {Menu} from "@mui/material";
import {declOfNum} from "@/Helpers/Function";
import Svg from "@/Components/Svg";
import Link from "@/Layouts/Link";

const BonusesComponent = (props) => {
    const {productDataCurrent = {}} = props;
    const [anchorEl, setAnchorEl] = useState(false);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(false);
    };

    const {bonusesAdd = 0} = productDataCurrent;

    return <>
        <div className={`bonusesContainer`} onClick={(e) => handleOpen(e)}>
            {bonusesAdd > 0 ?
                <p>PLATINA BENEFITS: Будет
                    начислено {bonusesAdd.toLocaleString('ru')}&nbsp;{declOfNum(bonusesAdd, ['бонус', 'бонуса', 'бонусов'])}</p>
                :
                <p>Ёще выгоднее с бонусами</p>
            }
            <Svg id={`warningInfo`} className={`svg--bonusesInfo`} />
        </div>
        <Menu id={`menu`}
              className={`bonusesInfoMenu`}
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={(event) => handleClose(event)}
        >
            <div className={`dagger-box`} onClick={(event) => handleClose(event)}>
                <Svg id={`dagger-close`} className={`svg__dagger-close`} />
            </div>
            <div className={`bonusesInfoMenu__body`}>
                <p className={`bonusesInfoMenu__text`}>
                    Бонусные баллы позволяют экономить при совершении новых покупок
                </p>
                <div style={{width: '100%'}}>&nbsp;</div>
                <Link
                    href={`/platina-benefits`}
                    className={`bonusesInfoMenu__link`}
                    onClick={(event) => handleClose(event)}
                >
                    Подробнее
                </Link>
            </div>
        </Menu>
    </>
}

export default BonusesComponent;
